import { combineReducers } from 'redux';

import actionsReducer from './actions';
import dashboard from './dashboard';
import detailsReducer from './details';
import planningReducer from '../../../planning/reducer';

export default combineReducers({
  actions: actionsReducer,
  details: detailsReducer,
  planning: planningReducer,
  dashboard,
});
